import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { IoGridSharp } from "react-icons/io5";
import { TfiLayoutGrid4Alt } from "react-icons/tfi";
import {
  MdOutlineFormatAlignJustify,
  MdOutlineKeyboardArrowDown,
} from "react-icons/md";
import { GiPlainSquare } from "react-icons/gi";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import useIsMobile from "../../../hooks/useIsMobile";

const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;
const Container = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr 180px;
  align-items: center;
  height: 45px;
  border-top: 1px solid ${colors.line};
  border-bottom: 1px solid ${colors.line};
  @media (max-width: 950px) {
    grid-template-columns: 1fr 2fr;
  }
`;
const Grids = styled.div`
  display: flex;
  gap: 12px;
  height: 100%;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${colors.line};
`;
const IconWrapper = styled.div`
  cursor: pointer;
  color: ${({ $selected }) =>
    $selected ? colors.black : colors.secondaryGray};
  &:hover {
    color: ${colors.black};
  }
`;
const Total = styled.div`
  text-align: center;
  span {
    font-size: ${fontSize.xs};
    color: ${colors.primaryGray};
  }
  @media (max-width: 950px) {
    display: none;
  }
`;
const Sort = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${colors.primaryGray};
  border-left: 1px solid ${colors.line};

  span {
    font-size: ${fontSize.xs};
    margin-right: 4px;
  }

  @media (max-width: 950px) {
    border: none;
  }
`;
const Dropdown = styled.ul`
  position: absolute;
  top: 100%;
  right: 0;
  width: 180px;
  background: #fff;
  border: 1px solid ${colors.line};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  z-index: 100;
`;
const DropdownItem = styled.li`
  padding: 8px 12px;
  cursor: pointer;
  &:hover {
    color: ${colors.black};
  }
`;

const DESKTOP_GRIDS = [
  { cols: 3, icon: <IoGridSharp size={20} /> },
  { cols: 4, icon: <TfiLayoutGrid4Alt size={20} /> },
  { cols: 5, icon: <MdOutlineFormatAlignJustify size={24} /> },
];
const MOBILE_GRIDS = [
  { cols: 2, icon: <IoGridSharp size={20} /> },
  { cols: 1, icon: <GiPlainSquare size={20} /> },
];

const SORT_OPTIONS = [
  "Popularity",
  "Price: Low to High",
  "Price: High to Low",
  "Newest",
];

export default function ProductFilter({ selectedGridOption, onGridChange, total }) {
  const isMobile = useIsMobile();
  const grids = isMobile ? MOBILE_GRIDS : DESKTOP_GRIDS;

  const [sortOpen, setSortOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setSortOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <Wrapper>
      <Container>
        <Grids>
          {grids.map(({ cols, icon }) => (
            <IconWrapper
              key={cols}
              $selected={selectedGridOption === cols}
              onClick={() => onGridChange(cols)}
            >
              {icon}
            </IconWrapper>
          ))}
        </Grids>
        <Total>
          <span>{total} PRODUCTS</span>
        </Total>
        <Sort ref={dropdownRef} onClick={() => setSortOpen(!sortOpen)}>
          <span>SORT BY</span>
          <MdOutlineKeyboardArrowDown size={20} />
          {sortOpen && (
            <Dropdown>
              {SORT_OPTIONS.map((option) => (
                <DropdownItem key={option}>{option}</DropdownItem>
              ))}
            </Dropdown>
          )}
        </Sort>
      </Container>
    </Wrapper>
  );
}
